import React from "react";
import { Box } from "@mui/material";

const LiveDot = ({ color = "#00ff41" }) => (
  <Box
    sx={{
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: color,
      display: "inline-block",
      mr: 0.8,
      boxShadow: `0 0 0 0 ${color}aa`,
      animation: "casino-live-pulse 1.4s ease-out infinite",
      "@keyframes casino-live-pulse": {
        "0%": { boxShadow: `0 0 0 0 ${color}88` },
        "70%": { boxShadow: `0 0 0 8px ${color}00` },
        "100%": { boxShadow: `0 0 0 0 ${color}00` },
      },
    }}
  />
);

export default LiveDot;
